import { render } from "./BlModelSearch.vue?vue&type=template&id=3d46aa55&scoped=true"
import script from "./BlModelSearch.vue?vue&type=script&lang=js"
export * from "./BlModelSearch.vue?vue&type=script&lang=js"

import "./BlModelSearch.vue?vue&type=style&index=0&id=3d46aa55&scoped=true&lang=scss"

import exportComponent from "/tmp/3a52593b-0c57-4976-8665-ec4c8a4d9b76/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d46aa55"]])

export default __exports__